import React from 'react';
import Image from 'components/image';
import PropTypes from 'prop-types';
import cn from 'classnames';
import useBreakpoints from 'hooks/use-breakpoints';
import { imageSourceBreakpoints } from 'js/breakpoints';

const SpecimenSearchTeaser = ({
  url,
  heading,
  image,
  categoryLabel,
  className,
  preloadImage,
}) => {
  const { isMobile } = useBreakpoints(true);

  return (
    <a
      href={url}
      className={cn('specimen-search-teaser', {
        [className]: className,
      })}
    >
      <div
        className="specimen-search-teaser__background"
        role="presentation"
      ></div>
      <div className="specimen-search-teaser__container">
        <div className="specimen-search-teaser__image-aligner">
          <div
            className={cn('specimen-search-teaser__image-holder', {
              'specimen-search-teaser__image-holder_no-image': !image,
            })}
          >
            {image && (
              <Image
                {...image}
                sources={[
                  {
                    width: 190,
                    height: 183,
                    media: imageSourceBreakpoints.xs,
                  },
                  {
                    width: 324,
                    height: 280,
                    media: imageSourceBreakpoints.s,
                  },
                  {
                    width: 262,
                    height: 226,
                    media: imageSourceBreakpoints.m,
                  },
                  {
                    width: 288,
                    height: 250,
                    media: imageSourceBreakpoints.l,
                  },
                ]}
                {...(!preloadImage && { loading: 'lazy' })}
                {...(preloadImage && { fetchPriority: 'high' })}
                fluid={isMobile}
                className="specimen-search-teaser__image image_size_specimen-search-teaser"
              />
            )}
          </div>
        </div>
        <div className="specimen-search-teaser__content">
          {categoryLabel && (
            <span className="specimen-search-teaser__category">
              {categoryLabel}
            </span>
          )}
          {heading && (
            <h2 className="specimen-search-teaser__heading">
              <span className="specimen-search-teaser__heading-text">
                {heading}
              </span>
            </h2>
          )}
        </div>
      </div>
    </a>
  );
};

SpecimenSearchTeaser.propTypes = {
  id: PropTypes.string,
  url: PropTypes.string,
  heading: PropTypes.string,
  className: PropTypes.string,
  image: PropTypes.exact(Image.propTypes),
  categoryLabel: PropTypes.string,
  preloadImage: PropTypes.bool,
};

SpecimenSearchTeaser.viewModelMeta = {
  className: 'ignore',
  preloadImage: 'ignore',
};

export default SpecimenSearchTeaser;
